import React, { useEffect, useRef, useState } from "react";
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../tvapk.css';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import { getEnvUrl, handleFileValidation } from "../../../../utils/Api";
import { createTvApkProject, updateTvApkProject, getTvApkProjectByID } from "../../../../Services/TvApksService/TvApkService";

const CreateEditTvApk = ({ isShow, close, type, projectId }) => {
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [tvApkName, setTvApkName] = useState("");
  const [tvApkNameError, setTvApkNameError] = useState(false);
  const tvApkNameRef = useRef(null);

  useEffect(() => {
    setShow(isShow);
    if (type === "EDIT" && projectId) {
      fetchTvApkDetails();
    }
  }, [isShow, type, projectId]);

  const fetchTvApkDetails = async () => {
    try {
      const response = await getTvApkProjectByID(projectId);
      if (response?.status) {
        setTvApkName(response.data.name || "");
        // setTvAppId(response.data.app_id || "");
        // setPreview(`${getEnvUrl()}/tvapk/getTvApkicon?id=${response.data.id}`);  
      } else {
        toast.error("Failed to fetch tvapk details");
      }
    } catch (error) {
      console.error("Error fetching tvapk details:", error);
    }
  };

  const handleSubmit = async () => {
    if (type === "CREATE") {
      if (!tvApkName.trim()) {
        setTvApkNameError(!tvApkName.trim());

        let object = [
          { key: tvApkName.trim(), ref: tvApkNameRef.current },
        ];

        for (let i = 0; i < object.length; i++) {
          if (!object[i].key) {
            object[i].ref.focus();
            break;
          }
        }
        return;
      }
    }
    if (type === "EDIT") {
      if (!tvApkName.trim()) {
        setTvApkNameError(!tvApkName.trim());

        let object = [
          { key: tvApkName.trim(), ref: tvApkNameRef.current },
        ];

        for (let i = 0; i < object.length; i++) {
          if (!object[i].key) {
            object[i].ref.focus();
            break;
          }
        }
        return;
      }
    }
    setIsLoading(true);
    setIsDisabled(true);

    const payload = {
      name: tvApkName.trim(),
    };
    try {
      let response;
      if (type === "CREATE") {
        response = await createTvApkProject(payload);
      } else {
        payload.id = projectId;
        response = await updateTvApkProject(payload);
      }

      if (response.status) {
        toast.success(response.message);
        close();
      } else {
        toast.error(response.errorMessage);
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setIsLoading(false);
      setIsDisabled(false);
    }
  };

  return (
    <Modal show={show} onHide={() => close(false)}>
      <Modal.Header closeButton>
        <h5 className="modal-title">{type === "CREATE" ? "Add Project" : "Edit Project"}</h5>
      </Modal.Header>
      <Modal.Body>
        <form className="row g-3" onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
          <div className="col-12 px-3">
            <label htmlFor="tvApkName" className="form-label required">Name</label>
            <input
              id='tvApkName'
              ref={tvApkNameRef}
              maxLength={35}
              value={tvApkName}
              onChange={(e) => {
                setTvApkName(e.target.value);
                if (tvApkNameError && e.target.value.trim() !== '') {
                  setTvApkNameError(false);
                }
              }}
              type="text"
              className="form-control"
              placeholder="Enter Project Name"
            />
            <Form.Control.Feedback type="invalid" style={{ display: tvApkNameError ? 'block' : 'none' }}>
              Project name is required
            </Form.Control.Feedback>
          </div>

          {isLoading && <div className="progress-bar"></div>}
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
              onClick={() => close(false)}
            >
              Close
            </button>
            <button
              disabled={isDisabled}
              type="submit"
              className="btn btn-primary"
            >
              {type === "CREATE" ? "Save" : "Update"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateEditTvApk;
